// extracted by mini-css-extract-plugin
export default {"form":"DataUserForm_form__h+Zqf"};